import { render, staticRenderFns } from "./ilist.vue?vue&type=template&id=cbece3ea"
import script from "./ilist.vue?vue&type=script&lang=js"
export * from "./ilist.vue?vue&type=script&lang=js"
import style0 from "./ilist.vue?vue&type=style&index=0&id=cbece3ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports